<div class="heading">
  <svg-icon src="/assets/svg/bullhorn.svg" [attr.style]="'color:var(--oneok-gray-400)'" />
  @if ($notification()?.title) {
  <p>{{ $notification()?.title }}</p>
  }
</div>
<div class="content" [innerHTML]="$notification()?.body"></div>
<button type="button" class="naked" (click)="clearAppNotification()">
  <svg-icon src="/assets/svg/x--small.svg" />
</button>
